import { send } from 'server';

export const forgotUsername = ({ token, casinoName, verificationBirthDate, email }) => send({
    ID: 35520,
    responses: [35521, 35522],
    description: 'Forgot username',
    token,
    casinoName,
    verificationBirthDate,
    email,
    errorLevel: 1
});
